export default "__VITE_ASSET__D6m_umcM__"